export default [
  {
    path: "/report/dashboard",
    name: "reportDashboard",
    component: () => import("@/view/report/dashboard/index.vue"),
  },
];
